import React from 'react'
import { Separator } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import SubPersonPageDecoratorSkeleton from '../common/SubPersonPageDecoratorSkeleton'
import NotesCardSkeleton from '../person-page/cards/notes-card/NotesCardSkeleton'
import DiscussionsCardSkeleton from '../person-page/cards/discussions-card/DiscussionsCardSkeleton'

export default function NotesPageSkeleton(): JSX.Element {
  const hideDiscussions = useFeatureFlag('treeWebTx_personR9_hideDiscussions').isOn
  return (
    <SubPersonPageDecoratorSkeleton>
      <NotesCardSkeleton />
      {!hideDiscussions && (
        <>
          <Separator size="sm" />
          <DiscussionsCardSkeleton />
        </>
      )}
    </SubPersonPageDecoratorSkeleton>
  )
}
